/** RTK Query unwrap rejects with an object, not necessarily an Error instance. */
export function getApiError(error: unknown): { code?: string; message?: string } {
  if (error instanceof Error) return { message: error.message };
  if (!error || typeof error !== 'object') return {};
  const value = error as { data?: { errorCode?: string; errorMessage?: string }; error?: string; message?: string };
  return { code: value.data?.errorCode, message: value.data?.errorMessage || value.error || value.message };
}
